import { render, staticRenderFns } from "./VirtualTable.vue?vue&type=template&id=774125ca&scoped=true"
import script from "./VirtualTable.vue?vue&type=script&lang=js"
export * from "./VirtualTable.vue?vue&type=script&lang=js"
import style0 from "./VirtualTable.vue?vue&type=style&index=0&id=774125ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774125ca",
  null
  
)

export default component.exports